<template>
  <div class="footer">
    <div class="footer-main">
      <p>&copy;Funcreate Digital Limited All Rights Reserved.</p>
      <p><router-link target="_blank" v-if="pageData.privacy" :to="pageData.url">{{pageData.privacy}}</router-link> </p>
    </div>
  </div>
</template>

<script>
  export default{
    data(){
      return{
        data:''
      }
    },
    computed: {
      pageData() {
        return this.$store.state.languagesData.footer;
      }
    },
    props: {
        resData: {}
    },
    watch: {
        resData(newData){
            this.data=newData;
        }
    },
  }
</script>

<style scoped>
  .footer{
    height: 129px;
    background: url('~@/assets/images/footer-bg.png') right no-repeat;
    background-size: auto 100%;
    box-sizing: border-box;
    position: relative;
  }
  .footer-main{
    padding: 0 3%;
    display: block;
    width: 100%;
    text-align: center;
    box-sizing: border-box;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }
  .footer-main p,.footer-main p a{
    color: white;
    font-size: 18px;
  }
  .footer-main p:nth-of-type(2){
    cursor: pointer;
    margin-top: 10px;
  }
  @media screen and (max-width: 1000px){
    .footer-main p{
      color: white;
      font-size: 16px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue